import React, { useState } from "react";
import { FaStore, FaBoxes, FaShoppingCart, FaLayerGroup, FaBasketballBall } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";

const models = [
  { name: "Daisy", category: "Semi-Verticals", image: "images/newdaisy.jpg", description: "Compact and efficient semi-vertical unit ideal for supermarkets and C-stores.", route: "/daisy-lower" },
  { name: "Futuro Combi", category: "Semi-Verticals", image: "images/futurocombi.png", description: "A semi-vertical design offering display and storage capabilities in a compact format for supermarkets.", route: "/FuturoCombi-lower" },
  { name: "United", category: "Multi decks", image: "images/united.png", description: "A robust multi-deck unit offering ample space for a diverse range of supermarket products.", route: "/united" },
  // { name: "Futuro 2", category: "Display", image: "images/futuro2.jpg", description: "A premium display model that ensures high product visibility and accessibility for supermarkets.", route: "/futuro-2" },
  { name: "FUTURO 2", category: "Multi decks", image: "images/futunew.jpg", description: "The most complete and flexible solution for modern food retail.", route: "/FUTURO-22" },
  { name: "Vista Grab & Go", category: "Semi-Verticals", image: "images/vistsgrab.jpg", description: "Perfect for quick transactions in supermarkets with its grab-and-go functionality.", route: "/vista-grab-and-go" },
  { name: "Columbus", category: "Display", image: "images/columbus.jpg", description: "An efficient display design perfect for supermarket environments to increase customer engagement.", route: "/Columbus-lower" },
  { name: "Prestige 2", category: "Display", image: "images/pristage.jpg", description: "An upscale model offering a sleek design and advanced features for modern supermarkets.", route: "/prestige2" },
  { name: "Daisy", category: "Display", image: "images/daisy22.jpg", description: "A versatile and functional line with all the options for the food retail.", route: "/daisy-upper" },
  { name: "Futuro 2", category: "Semi-Verticals", image: "images/FUTURO-upper.jpg", description: "Sleek and stylish semi-vertical sushi display perfect for modern restaurants.", route: "/FUTURO2-upper" },
  { name: "Futuro 2", category: "Semi-Verticals", image: "images/futuro2new.jpg", description: "Space-efficient and stylish semi-vertical unit for supermarket environments.", route: "/futuro-2" },
  { name: "COLUMBUS", category: "Multi decks", image: "images/columbsnew.jpg", description: "Efficient multi-deck solution for maximizing product display in supermarkets.", route: "/columbus" },
  { name: "Victory", category: "Semi-Verticals", image: "images/victory.png", description: "A high-end semi-vertical design perfect for premium supermarkets and C-stores.", route: "/victory" },
  { name: "Urban", category: "More solutions", image: "images/urban.jpg", description: "A contemporary solution designed to meet the needs of urban supermarket environments.", route: "/urban" },
  { name: "Expo BZ", category: "Islands", image: "images/expo.png", description: "A sophisticated island design ideal for supermarkets and C-stores to create an inviting shopping experience.", route: "/EXPOBZ" },
  { name: "Futuro Island", category: "Islands", image: "images/futuruisland2.png", description: "A modern, space-saving island design that enhances the in-store shopping experience.", route: "/FUTUROISLAND" },
  { name: "Futuro Expo", category: "Islands", image: "images/futuroexpo1.jpg", description: "Expo-style island with premium product display features, perfect for supermarkets and C-stores.", route: "/FUTUROEXPO" },
  { name: "Click & Collect", category: "Intelligent Solutions", image: "images/clickcollect.png", description: "A smart solution that enables customers to place orders online and collect them from the store.", route: "/CLICK&COLLECT" },
 
];


const icons = [
  { name: "Supermarket", icon: <FaStore /> },
  { name: "Shipping", icon: <FaBoxes /> },
  { name: "Shopping Cart", icon: <FaShoppingCart /> },
  { name: "Layered Display", icon: <FaLayerGroup /> },
  { name: "Sports Goods", icon: <FaBasketballBall /> },
];

function Supermarket() {
  const [currentPage, setCurrentPage] = useState(1);
  const modelsPerPage = 6;
  const navigate = useNavigate();

  // Get the current models for the current page
  const indexOfLastModel = currentPage * modelsPerPage;
  const indexOfFirstModel = indexOfLastModel - modelsPerPage;
  const currentModels = models.slice(indexOfFirstModel, indexOfLastModel);

  // Handle page change
  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate total pages
  const totalPages = Math.ceil(models.length / modelsPerPage);

  return (
    <div className="w-full font-thin">
      {/* Hero Section */}
      <section
        className="relative text-center w-full h-[600px]"
        style={{
          backgroundImage: "url('images/supermarkland1.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
       
      </section>

      {/* Models Display */}
      <section className="px-6 py-12 md:px-32">
        <section className="px-6 md:px-32">
        <div className="flex flex-col items-center justify-center text-black p-6">
          <h1 className="text-3xl mb-4 md:text-4xl text-center">Supermarket & C-Stores</h1>
          <p className="text-lg max-w-2xl text-center md:text-2xl text-gray-500">
          360º solutions for Modern Distribution: horizontal and vertical displays, at positive or negative temperature and for hot food as well.
          </p>
        </div>

        <div className="flex justify-center">
          <Link to="/" className="block py-1 pl-4 hover:underline mt-6">Home -</Link>
          <button className="block py-1 pl-4 hover:underline uppercase mt-6">Supermarket & C-Stores</button>
        </div>
      </section>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {currentModels.map((model, index) => (
            <div key={index} onClick={() => navigate(model.route)} className="text-center cursor-pointer">
              <div
                className="relative w-full h-80 mb-4"
                style={{
                  backgroundImage: `url(${model.image})`,
                  backgroundSize: "contain", // Ensures no cuts, full image shown
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  height: "300px",
                }}
              ></div>
              <h3 className="text-3xl uppercase font-thin mb-2">{model.name}</h3>
              {/* <p className="text-xl opacity-80 ">{model.category}</p> */}
              <p className="text-xl text-gray-500 max-w-sm opacity-80 mb-4 mx-auto">{model.description}</p>

              {/* Small icons under each model */}
              <div className="flex justify-center gap-4">
                {icons.map((icon, index) => (
                  <div key={index} className="text-2xl">
                    {icon.icon}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Pagination */}
        <div className="flex justify-center mt-10">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="px-4 py-2 bg-gray-800 text-white rounded-l"
          >
            Previous
          </button>
          <span className="px-4 py-2">{`Page ${currentPage} of ${totalPages}`}</span>
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="px-4 py-2 bg-gray-800 text-white rounded-r"
          >
            Next
          </button>
        </div>
      </section>
    </div>
  );
}

export default Supermarket;

// import React from 'react';

// function Supermarket() {
//   return (
//     <div>
//       <section
//         className="relative text-center w-full h-screen"
//         style={{
//           backgroundImage: "url('images/supermarkland1.jpg')",
//           backgroundSize: 'cover',
//           backgroundPosition: 'center',
//           backgroundRepeat: 'no-repeat'
//         }}
//       >
//         <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50 text-white p-6">
//           <h1 className="text-4xl font-bold mb-4 md:text-8xl">Supermarket & C-Stores</h1>
//         </div>
//       </section>

//       <div className="flex flex-col xl:gap-20 xl:px-20">
//         {/* Header Section */}
//         <header className="text-center pt-20">
//           <h1 className="text-4xl md:text-5xl lg:text-7xl xl:text-8xl font-extrabold text-gray-900 mb-8">
//             Supermarket Equipment Solutions
//           </h1>
//         </header>

//         {/* Equipment Categories */}
//         <section className="mb-16 px-3 flex flex-col xl:flex-row gap-6 xl:gap-0 justify-between items-center">
//           <h2 className="text-2xl md:text-6xl 2xl:text-8xl font-semibold text-gray-800 text-center">
//             Elevate Your Business with Our Equipment
//           </h2>
//           <p className="text-xl md:text-2xl 2xl:text-4xl text-gray-700 xl:max-w-2xl 2xl:max-w-3xl text-justify">
//             We offer a comprehensive range of supermarket and convenience store equipment designed to optimize 
//             space, improve customer experience, and boost sales. Discover our wide selection of innovative solutions.
//           </p>
//         </section>

//         {/* Display Solutions */}
//         <section className="mb-16 px-3 xl:p-20 flex flex-col xl:flex-row gap-10 md:gap-20 justify-center items-center bg-gradient-to-r from-gray-800 to-indigo-600/50 py-16 rounded-xl shadow-lg">
//           <h2 className="text-4xl md:text-6xl 2xl:text-8xl font-semibold text-white text-center drop-shadow-lg">
//             Display Solutions
//           </h2>
//           <p className="text-xl md:text-2xl 2xl:text-4xl text-white xl:max-w-2xl 2xl:max-w-3xl text-justify mt-6 opacity-90">
//             Showcase your products in style with our advanced display solutions, designed to keep 
//             your offerings fresh and visually appealing. Our display units include:
//           </p>
//         </section>

//         {/* Cards for Display Solutions */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12 px-3 mt-12">
//           <div className="group relative transform transition duration-500 ease-in-out hover:scale-105 hover:shadow-xl rounded-xl overflow-hidden border border-gray-700">
//             <div className="relative w-full h-72">
//               <img
//                 src="images/futuro2.jpg"
//                 alt="Futuro 2 Display"
//                 className="w-full h-full object-contain rounded-t-xl"
//               />
//             </div>
//             <div className="relative z-10 p-6">
//               <div className="bg-gradient-to-r from-gray-800 to-indigo-600/50 backdrop-blur-md rounded-xl p-4">
//                 <h3 className="text-2xl font-bold text-white">Futuro 2</h3>
//                 <p className="text-lg text-white opacity-90 mt-4">
//                   Perfect for modern retail environments, Futuro 2 offers excellent product visibility and efficient use of space.
//                 </p>
//               </div>
//             </div>
//           </div>

//           <div className="group relative transform transition duration-500 ease-in-out hover:scale-105 hover:shadow-xl rounded-xl overflow-hidden border border-gray-700">
//             <div className="relative w-full h-72">
//               <img
//                 src="images/daisy.jpg"
//                 alt="Daisy Display"
//                 className="w-full h-full object-contain rounded-t-xl"
//               />
//             </div>
//             <div className="relative z-10 p-6">
//               <div className="bg-gradient-to-r from-gray-800 to-indigo-600/50 backdrop-blur-md rounded-xl p-4">
//                 <h3 className="text-2xl font-bold text-white">Daisy</h3>
//                 <p className="text-lg text-white opacity-90 mt-4">
//                   Bring a touch of elegance to your space with the Daisy series, designed for simplicity and functionality.
//                 </p>
//               </div>
//             </div>
//           </div>

//           <div className="group relative transform transition duration-500 ease-in-out hover:scale-105 hover:shadow-xl rounded-xl overflow-hidden border border-gray-700">
//             <div className="relative w-full h-72">
//               <img
//                 src="images/columbus.jpg"
//                 alt="Columbus Display"
//                 className="w-full h-full object-contain rounded-t-xl"
//               />
//             </div>
//             <div className="relative z-10 p-6">
//               <div className="bg-gradient-to-r from-gray-800 to-indigo-600/50 backdrop-blur-md rounded-xl p-4">
//                 <h3 className="text-2xl font-bold text-white">Columbus</h3>
//                 <p className="text-lg text-white opacity-90 mt-4">
//                   Columbus provides cutting-edge display technology, ideal for high-traffic areas.
//                 </p>
//               </div>
//             </div>
//           </div>

//           <div className="group relative transform transition duration-500 ease-in-out hover:scale-105 hover:shadow-xl rounded-xl overflow-hidden border border-gray-700">
//             <div className="relative w-full h-72">
//               <img
//                 src="images/prestige2.jpg"
//                 alt="Prestige 2 Display"
//                 className="w-full h-full object-contain rounded-t-xl"
//               />
//             </div>
//             <div className="relative z-10 p-6">
//               <div className="bg-gradient-to-r from-gray-800 to-indigo-600/50 backdrop-blur-md rounded-xl p-4">
//                 <h3 className="text-2xl font-bold text-white">Prestige 2</h3>
//                 <p className="text-lg text-white opacity-90 mt-4">
//                   Prestige 2 blends classic design with innovative display solutions.
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Intelligent Solutions */}
//         <section className="mt-16 px-3 flex flex-col xl:flex-row gap-6 xl:gap-0 justify-between items-center">
//           <h2 className="text-2xl md:text-6xl 2xl:text-8xl font-semibold text-gray-800 text-center">
//             Intelligent Solutions
//           </h2>
//           <p className="text-xl md:text-2xl 2xl:text-4xl text-gray-700 xl:max-w-2xl 2xl:max-w-3xl text-justify mt-6">
//             Take your supermarket to the next level with smart solutions for enhanced customer experience. 
//             Our intelligent solutions include:
//           </p>
//         </section>

//         {/* Cards for Intelligent Solutions */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12 px-3 mt-12">
//           <div className="group relative transform transition duration-500 ease-in-out hover:scale-105 hover:shadow-xl rounded-xl overflow-hidden border border-gray-700">
//             <div className="relative w-full h-72">
//               <img
//                 src="images/click_collect.jpg"
//                 alt="Click & Collect"
//                 className="w-full h-full object-contain rounded-t-xl"
//               />
//             </div>
//             <div className="relative z-10 p-6">
//               <div className="bg-gradient-to-r from-gray-800 to-indigo-600/50 backdrop-blur-md rounded-xl p-4">
//                 <h3 className="text-2xl font-bold text-white">Click & Collect</h3>
//                 <p className="text-lg text-white opacity-90 mt-4">
//                   A seamless click-and-collect service to drive sales and enhance customer convenience.
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Islands */}
//         <section className="mt-16 px-3 flex flex-col xl:flex-row gap-6 xl:gap-0 justify-between items-center">
//           <h2 className="text-2xl md:text-6xl 2xl:text-8xl font-semibold text-gray-800 text-center">
//             Islands
//           </h2>
//           <p className="text-xl md:text-2xl 2xl:text-4xl text-gray-700 xl:max-w-2xl 2xl:max-w-3xl text-justify mt-6">
//             Explore our range of islands to maximize store efficiency and customer engagement:
//           </p>
//         </section>

//         {/* Cards for Islands */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12 px-3 mt-12">
//           <div className="group relative transform transition duration-500 ease-in-out hover:scale-105 hover:shadow-xl rounded-xl overflow-hidden border border-gray-700">
//             <div className="relative w-full h-72">
//               <img
//                 src="images/expo_bz.jpg"
//                 alt="Expo BZ"
//                 className="w-full h-full object-contain rounded-t-xl"
//               />
//             </div>
//             <div className="relative z-10 p-6">
//               <div className="bg-gradient-to-r from-gray-800 to-indigo-600/50 backdrop-blur-md rounded-xl p-4">
//                 <h3 className="text-2xl font-bold text-white">Expo BZ</h3>
//                 <p className="text-lg text-white opacity-90 mt-4">
//                   The Expo BZ island brings a modular solution for all your retail needs.
//                 </p>
//               </div>
//             </div>
//           </div>

//           <div className="group relative transform transition duration-500 ease-in-out hover:scale-105 hover:shadow-xl rounded-xl overflow-hidden border border-gray-700">
//             <div className="relative w-full h-72">
//               <img
//                 src="images/futuro_island.jpg"
//                 alt="Futuro Island"
//                 className="w-full h-full object-contain rounded-t-xl"
//               />
//             </div>
//             <div className="relative z-10 p-6">
//               <div className="bg-gradient-to-r from-gray-800 to-indigo-600/50 backdrop-blur-md rounded-xl p-4">
//                 <h3 className="text-2xl font-bold text-white">Futuro Island</h3>
//                 <p className="text-lg text-white opacity-90 mt-4">
//                   Futuro Island is the perfect choice for high-traffic store layouts.
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Supermarket;
